import '../styles/globals.css'

// Home page - static for now, can add interactivity later
console.log('Game Hub loaded')
